module.exports = __webpack_public_path__ + "assets/voucher-canceled-icon-2d21c6.svg";